import apiClient from './api';

export interface ServiceProviderSettlementListParams {
  page?: number;
  pageSize?: number;
  status?: 'pending' | 'settled';
  orderNo?: string;
  customerName?: string;
  customerPhone?: string;
  startDate?: string;
  endDate?: string;
}

export interface ServiceProviderSettlementListItem {
  id: string;
  orderId: string;
  subOrderId: string;
  orderNo: string;
  subOrderNo: string;
  contactName: string;
  contactPhone: string;
  serviceAddress: string;
  serviceContent: string;
  settlementAmount: number;
  status: string;
  serviceDate: string;
  completedAt: string;
  settledAt: string;
  eligibleSettleAt: string;
  createdAt: string;
}

export interface ServiceProviderWithdrawRecordListParams {
  page?: number;
  pageSize?: number;
  startDate?: string;
  endDate?: string;
}

export interface ServiceProviderWithdrawRecordListItem {
  id: string;
  amount: number;
  method: string;
  methodText: string;
  accountName: string;
  accountNo: string;
  status: string;
  statusRemark: string;
  beforeBalance: number;
  afterBalance: number;
  requestedAt: string;
  reviewedAt: string;
  arrivedAt: string;
  createdAt: string;
}

export interface PaginatedListResponse<T> {
  list: T[];
  total: number;
  page: number;
  pageSize: number;
}

export const listServiceProviderSettlements = async (
  id: string,
  params?: ServiceProviderSettlementListParams,
): Promise<PaginatedListResponse<ServiceProviderSettlementListItem>> => {
  const response = await apiClient.get<PaginatedListResponse<ServiceProviderSettlementListItem>>(
    `/service-providers/${id}/settlements`,
    { params },
  );
  return response.data;
};

export const listServiceProviderWithdrawRecords = async (
  id: string,
  params?: ServiceProviderWithdrawRecordListParams,
): Promise<PaginatedListResponse<ServiceProviderWithdrawRecordListItem>> => {
  const response = await apiClient.get<PaginatedListResponse<ServiceProviderWithdrawRecordListItem>>(
    `/service-providers/${id}/withdraw-records`,
    { params },
  );
  return response.data;
};
